// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.scaffold-card-operator-detail {\n    display: flex;\n    flex-wrap: wrap;\n    flex: 1\n}", "",{"version":3,"sources":["webpack://./src/components/Operators/OperatorDetail.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,eAAe;IACf;AACJ","sourcesContent":["\n.scaffold-card-operator-detail {\n    display: flex;\n    flex-wrap: wrap;\n    flex: 1\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
